import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';;

@Component({
  selector: 'iho-footer-features',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss'],
})
export class FooterFeaturesComponent {
  cdnUrl = cdnUrl
  private searchBoxService = inject(SearchBoxService);
  accommodation = computed(() => this.searchBoxService.accommodation());
}
